export default {
  login: '/auth/login',
  checkAuthCode: '/auth/check-auth-code',
  forgotPassword: '/auth/forgot-password',
  changePassword: '/auth/change-password',
  confirmInvite: '/auth/confirm-invite',
  checkCode: '/users/check-code',
  currentUser: '/auth/current',
  logout: '/auth/logout',
  roles: '/roles',
  permissions: '/permissions',
  users: '/users',
  createInvite: '/users/create-invite',
  languages: '/languages',
  menus: '/menus',
  widgets: '/widgets',
  widgetsFiles: '/widgets-files',
  translations: '/translations',
  slides: '/slides',
  pages: '/pages',
  feedback: '/feedback',
  posts: '/posts',
  postsCategories: '/posts-categories',
  upload: '/temp-files/upload',
  metaData: '/meta-data',
  deleteTempFile: '/temp-files/delete',
  settings: '/settings',
  updateSitemap: '/settings/sitemap',
  slash: '/',
  testMailjet: '/test-mailjet',
  modules: '/modules',
  modulesColors: '/modules-colors',
  modulesCategories: '/modules-category',
  screenshotFiles: '/screenshot-files',
  subscribers: '/subscribers',
  licences: '/licences',
};



// WEBPACK FOOTER //
// ./src/services/api.routes.js